import React, { Suspense } from 'react';
const Onboading = React.lazy(() => import('components/login/Onboarding'));

const OnboadingWrapper = () => {
  return <Suspense fallback={<div></div>}>
  <Onboading />
</Suspense>;
};

export default OnboadingWrapper;